import { render, staticRenderFns } from "./N8nInstagramPostsHistoryTable.vue?vue&type=template&id=04a619bd&"
import script from "./N8nInstagramPostsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./N8nInstagramPostsHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports